// Module-level CSRF token service
// Stores CSRF token in a module-level variable (not React state, not localStorage, not cookies)
// This solves the cross-origin cookie reading issue between skateskout.com and api.skateskout.com

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Module-level token storage
let _csrfToken = null;

/**
 * Fetches CSRF token from the API and stores it in module-level variable
 * @returns {Promise<string|null>} The CSRF token or null if fetch fails
 */
export const fetchCsrfToken = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/csrf/`, {
      method: 'GET',
      credentials: 'include',
    });

    if (response.ok) {
      const data = await response.json();
      _csrfToken = data.csrfToken || null;
      return _csrfToken;
    }
    return null;
  } catch (error) {
    // Silently fail if CSRF endpoint is unavailable
    console.error('Failed to fetch CSRF token:', error);
    return null;
  }
};

/**
 * Gets the cached CSRF token synchronously
 * @returns {string|null} The cached CSRF token or null if not yet fetched
 */
export const getCsrfToken = () => {
  return _csrfToken;
};